import { useState } from 'react'

const CheckBox = ({
  checked,
  lable,
  value,
  onChange,
  className,
  name,
  disabled,
  id,
}: CheckBoxInterface) => {
  const [check, setCheck] = useState<boolean | undefined>(checked ?? false)
  if (!id) id = Math.random().toString()
  return (
    <>
      <div className='flex justify-center items-center gap-1'>
        <input
          disabled={disabled}
          type='checkbox'
          value={value}
          id={id}
          checked={check}
          name={name}
          onChange={(e) => {
            setCheck(e.currentTarget.checked)
            onChange && onChange(e)
          }}
          className='accent-primary'
        />
        <label
          htmlFor={id}
          className={`${className} w-full ml-2 text-sm font-medium text-gray-900 rounded`}
        >
          {lable}
        </label>
      </div>
    </>
  )
}

export default CheckBox
